<template>
    <div>
        <div class="mb-4 d-flex align-items-center">
            <div class="mb-2 text-center text-title" style="width:100%;"> {{title }}</div>
            <div class="ml-auto" style="min-width: 160px;">
                <el-radio-group v-model="showtype" size="small">
                    <el-radio-button size="small" label="current" title="Monthly">CTC</el-radio-button>
                    <el-radio-button size="small" label="ytd" title="YTD">YTD</el-radio-button>
                    <el-radio-button size="small" label="kas" title="Kas Setara Kas">KAS</el-radio-button>
                </el-radio-group>
            </div>
        </div>
        <LineChart :data="chartdata" :width="barChartSizeTop.width" :height="350"/>
    </div>
</template>

<script>
import Treasury from '@/components/page/Treasury.js'
import LineChart from '@/components/chart/LineChart.js'
import { Rainbow, Rainbow3, Penanggalan, AppColors, Config, AxiosWithJar } from '@/utility.js'
//import { ActivityPosition } from '@/data/treasury/Activity.js'

export default {
    extends: Treasury,
    components: { LineChart },
    props: {
        id: {
            type: String,
            default: '',
            //required: false,
        }
    },
    setup() {

    },
    mounted() {
        //this.setCashFlowData()
        this.getData()
    },
    data() {
        return {
            title: 'CASH FLOW / AKTIVITAS ' + Penanggalan().tahun,
            chartdata: [],
            resultdata: [],
            resultdatakas: [],
            barChartSizeTop: {
				width:500,
				height:200,
			},
            showtype: 'current',

            loading : {
                table: true,
                chart: true,
            }
        }
    },
    watch: {
        showtype() {
            if(this.showtype =='current')
                this.chartdata = this.processBarChart(this.resultdata, "Label", "", "Nilai", false, "MonthName", "", 1, 2, AppColors, "Grup", [1], true)
            else if(this.showtype =='ytd')
                this.chartdata = this.processBarChart(this.resultdata, "Label", "", "Ytd", false, "MonthName", "", 1, 2, AppColors, "Grup", [1], true)
            else if(this.showtype =='kas')
                this.chartdata = this.processBarChart(this.resultdatakas, "Label", "", "Nilai", false, "MonthName", "", 1, 2, AppColors, "Grup", [1], true)
        }
    },
    methods: {
		setCashFlowData() {
			//this.chartdata = this.processBarChart(ActivityPosition, "TitleName", "", "Nilai", false, "MonthName", "", 1, 2, AppColors, "Grup", [1], true)
		},


        async getData() {
			this.urlRequestParams=Config().apiURL
			this.urlRequestParams+='/v1/treasury/cashFlow?'
//
			//this.urlRequestParams+='&date-range-start='+ (this.dateRange && this.dateRange[0] ? this.dateRange[0] : '')
			//this.urlRequestParams+='&date-range-end='+ (this.dateRange && this.dateRange[1] ? this.dateRange[1] : '')
			//this.urlRequestParams+='&tahun='+this.year

			this.loading.table = true;
			this.loading.chart = true;
			AxiosWithJar().get(this.urlRequestParams)
				.then((response)=>{
					let data    = response.data.data.data.data;
                    this.resultdata = data;
                    this.resultdatakas = response.data.data.data.kas;
					this.title  = response.data.data.title.toUpperCase();
                    //console.log(JSON.stringify(balanceData));
                    if(response.data.data.data.data) {
                        this.chartdata = this.processBarChart(data, "Label", "", "Nilai", false, "MonthName", "", 1, 2, AppColors, "Grup", [1], true)
                    }
                })
				.catch(error => {
					console.log(error)
					//this.errored = true
					//error.response.data
				})
				.finally(() => {
					this.loading.chart = false;
					this.loading.table = false;
				})

        },
    }
}
</script>

<style>

</style>
